// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'card-stack';

export const Component = () => (
  <path d='M23.037 2H1.485c-.431 0-.766.144-1.054.431A1.408 1.408 0 0 0 0 3.485v8.813c0 .43.144.766.431 1.054.288.287.623.43 1.054.43h21.552a1.41 1.41 0 0 0 1.054-.43 1.41 1.41 0 0 0 .43-1.054V3.485a1.41 1.41 0 0 0-.43-1.054A1.408 1.408 0 0 0 23.037 2Zm.526 1.485v8.813c0 .335-.191.479-.526.479H1.485c-.335 0-.526-.144-.526-.48V3.486c0-.335.191-.526.526-.526h21.552c.335 0 .526.191.526.526Zm-1.484 12.26c.335 0 .479.144.479.48 0 .334-.144.478-.48.478H2.444c-.335 0-.479-.144-.479-.479 0-.335.144-.479.479-.479H22.08Zm-1.485 3.401c0 .335-.144.527-.48.527H4.407c-.335 0-.479-.192-.479-.527s.144-.479.48-.479h15.708c.335 0 .479.144.479.48Zm-2.442 2.49c.335 0 .478.144.478.48 0 .335-.143.479-.478.479H6.37c-.335 0-.479-.144-.479-.48 0-.335.144-.478.48-.478h11.78Z' />
);

export const viewBox = '0 0 25 25';
